import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import assistantSlice from './slices/assistantSlice';
import conversationSlice from './slices/conversationSlice';
import builderSlice from './slices/builderSlice';
import knowledgeSlice from './slices/knowledgeSlice';
import calendarSlice from './slices/calendarSlice';
import analyticsSlice from './slices/analyticsSlice';
import callStatsSlice from './slices/callStatsSlice';
import { socketMiddleware } from './middleware/socketMiddleware';
import conversationsSlice from './conversationsSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    assistants: assistantSlice,
    conversations: conversationSlice,
    builder: builderSlice,
    knowledge: knowledgeSlice,
    calendar: calendarSlice,
    analytics: analyticsSlice,
    callStats: callStatsSlice,
    conversations2: conversationsSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }).concat(socketMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;